import { Typography } from '@vp/visage'
import * as React from 'react'
import { getComponentProps } from './prop-section.utility'
import PropsTable from './props-table.component'
import styleClasses from './props-table.module.scss'

type PropsSectionProps = {
  component: string
  defaultComponent?: string
}

const PropsSection: React.FC<PropsSectionProps> = ({ component, defaultComponent }) => {
  const componentMeta = getComponentProps(component)
  if (!componentMeta) return null

  const hasOwnProps = Object.values(componentMeta.props).length > 0

  const propsMessage = (
    <>
      <span>All {hasOwnProps ? ' other' : ''} props are forwarded to the element specified in the</span>
      <code>component</code>
      <span>prop</span>
      {defaultComponent && (
        <span>
          (default: <code>{`<${defaultComponent}/>`}</code>)
        </span>
      )}
    </>
  )

  return (
    <div className={styleClasses.propsSection}>
      {componentMeta.displayName ? (
        <Typography component="h4" className="mt-4" textSize={4}>
          {componentMeta.displayName}
        </Typography>
      ) : null}
      <PropsTable component={component} />
      {propsMessage ? <p>{propsMessage}</p> : null}
    </div>
  )
}

export default PropsSection
